import React, { InputHTMLAttributes, useState } from "react";
import styled from "styled-components";

import { Colors } from "../../utils/colors";

interface IProps extends InputHTMLAttributes<HTMLInputElement> {
  required?: boolean;
}
const SearchInput = ({
  required,

  ...rest
}: IProps) => {
  const [focused, setFocused] = useState(false);
  return (
    <Container>
      <InputContainer focused={focused ? "true" : "false"}>
        <SearchIcon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M7.66732 14.0002C11.1651 14.0002 14.0007 11.1646 14.0007 7.66683C14.0007 4.16903 11.1651 1.3335 7.66732 1.3335C4.16951 1.3335 1.33398 4.16903 1.33398 7.66683C1.33398 11.1646 4.16951 14.0002 7.66732 14.0002Z"
              stroke="#909090"
            />
            <path
              d="M12.334 12.3335L14.6673 14.6668"
              stroke="#909090"
              stroke-linecap="round"
            />
          </svg>
        </SearchIcon>
        <Input
          {...rest}
          onFocus={() => {
            setFocused(true);
          }}
          onBlur={() => setFocused(false)}
        />
      </InputContainer>
    </Container>
  );
};

export default SearchInput;

const Container = styled.div`
  position: relative;
  width: 100%;
`;

const InputContainer = styled.div<{ focused?: string }>`
  width: 100%;
  padding: 1rem;
  border: 1px solid
    ${(props) => (props.focused === "true" ? Colors.primary : Colors.grey500)};
  border-radius: 0.8rem;
  transition: ease all 0.2s;
  display: flex;
  align-items: center;
  @media only screen and (max-width: 769px) {
    padding: 1rem 1.6rem;
  }
`;

const SearchIcon = styled.div`
  width: 1.6rem;
  margin-right: 1.2rem;
`;
const Input = styled.input<{ status?: string }>`
  font-family: "Switzer", sans-serif;
  width: 100%;
  outline: none;
  background: none;
  border: none;
  color: ${Colors.white200};
  font-family: "Inter", sans-serif;
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.6rem;
  &::placeholder {
    color: ${Colors.grey500};
  }
`;
